module.exports = __webpack_public_path__ + "static/media/JAI.5642828f.jpg";